import {gql} from '@apollo/client';
import {PodRiskReviewStatus, PodRiskReviewType} from '../types/PodRiskReviewType';

/**
 * 舆情 POD 审核工作台列表（分页 + 多筛选）
 *
 * 与 api-server `PodRiskReviewQuery.getPodRiskReviewPageList` 对应：参数为扁平的
 * filters / page / size；工作台 Tab 以 filters.isFinished 传入。
 */

/** 后端 PodRiskReviewFiltersTypeInput；时间为 ISO-8601 字符串，from 含、to 不含 */
export interface PodRiskReviewFiltersTypeInput {
    reviewTaskId?: string;
    /** 是否已完结；对应工作台 Tab（待审核 false / 已终止 true） */
    isFinished?: boolean;
    statuses?: PodRiskReviewStatus[];
    trackingNumbers?: string;
    channelOrderNumbers?: string;
    dspIds?: string[];
    driverIds?: string[];
    warehouseIds?: string[];
    /** 中心三段码，后端前缀匹配 */
    hubSortingCodes?: string[];
    /** 区域三段码，后端精确匹配 */
    areaSortingCodes?: string[];
    reviewerId?: string;
    riskTypeCodes?: string[];
    deliveredAtFrom?: string;
    deliveredAtTo?: string;
    createdAtFrom?: string;
    createdAtTo?: string;
    reviewedAtFrom?: string;
    reviewedAtTo?: string;
}

export const POD_RISK_REVIEW_ITEM_FIELDS = gql`
    fragment PodRiskReviewItemFields on PodRiskReviewItemType {
        reviewTaskId
        status
        slaDueAt
        reviewerId
        reviewer {
            name
        }
        reviewedAt
        finished
        finishedAt
        createdAt
        podRiskReviewId
        orderId
        trackingNumber
        dspId
        driverId
        driverName
        warehouseId
        warehouseName
        batchNo
        requestId
        machineHitTypes
        machineHitImageCount
        deliveredAt
        riskTypeCodes
        reviewRemark {
            text
            lang
            translations {
                lang
                text
            }
        }
    }
`;

export const GET_POD_RISK_REVIEW_PAGE_LIST = gql`
    ${POD_RISK_REVIEW_ITEM_FIELDS}
    query GetPodRiskReviewPageList($filters: PodRiskReviewFiltersTypeInput, $page: Int! = 1, $size: Int! = 20) {
        getPodRiskReviewPageList(filters: $filters, page: $page, size: $size) {
            content {
                ...PodRiskReviewItemFields
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface GetPodRiskReviewPageListResponse {
    getPodRiskReviewPageList: {
        content: PodRiskReviewType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetPodRiskReviewPageListInput {
    filters?: PodRiskReviewFiltersTypeInput;
    page?: number;
    size?: number;
}
